/**
 * Client-side DOS calculation for preview during knob adjustments.
 * Server-side calculation (Go Lambda) is authoritative.
 */

export function calculateDOS(endingInventory, nextMonthForecast, workingDays) {
  if (!nextMonthForecast || nextMonthForecast === 0) return Infinity
  const dailyRate = nextMonthForecast / workingDays
  if (dailyRate === 0) return Infinity
  return endingInventory / dailyRate
}

export function calculateEndingInventory(beginningInv, forecast, scheduledCases) {
  return beginningInv - forecast + scheduledCases
}

export function calculateAutoInventory(dosMin, percentOfMinInv, nextMonthForecast, workingDays, beginningInv, forecast, roundingValue) {
  const adjustedTargetDOS = dosMin * percentOfMinInv
  const dailyRate = nextMonthForecast / workingDays
  const targetEndingInv = adjustedTargetDOS * dailyRate

  const currentEndingWithoutProd = beginningInv - forecast
  const requiredProduction = targetEndingInv - currentEndingWithoutProd

  if (requiredProduction <= 0) return 0

  if (roundingValue > 0) {
    return Math.ceil(requiredProduction / roundingValue) * roundingValue
  }
  return Math.ceil(requiredProduction)
}

export function calculateRunRate(cpm, efficiency, packSize) {
  return (cpm * efficiency * 60) / packSize
}

export function calculateRequiredHours(scheduledCases, runRateCasesPerHour) {
  if (!runRateCasesPerHour || runRateCasesPerHour === 0) return 0
  return scheduledCases / runRateCasesPerHour
}

export function calculateEC(cases, ecPercentage) {
  return cases * ecPercentage
}

export function getDOSStatus(dos, dosMin, dosMax) {
  if (dos === Infinity) return 'ok'
  if (dos < 0) return 'critical'
  if (dos < dosMin) return 'critical'
  if (dos > dosMax) return 'aboveMax'
  return 'ok'
}
